class VideoNoteSection extends HTMLElement {
  constructor() {
    super();
    this.isControlsEnabled = this.hasAttribute('data-enable-controls');
    this.isAutoplayEnabled = this.hasAttribute('data-enable-autoplay');
  }

  connectedCallback() {
    this.mountComponent();
  }

  mountComponent() {
    if (this.isAutoplayEnabled) {
      this.loadVideo();
    } else {
      this.addEventListeners();
    }
  }

  addEventListeners() {
    const poster = this.querySelector('[data-video-poster]');
    const playButton = this.querySelector('[data-play-button]');
    
    if (poster) {
      poster.addEventListener('click', this.handlePosterClick.bind(this));
    }
    
    if (playButton) {
      playButton.addEventListener('click', this.handlePosterClick.bind(this));
    }
  }

  handlePosterClick(event) {
    event.stopPropagation();
    this.loadVideo();
  }

  loadVideo() {
    if (!this.getAttribute('data-loaded')) {
      const template = this.querySelector('[data-video-template]');
      const container = this.querySelector('[data-video-container]');
      
      if (template && container) {
        const videoContent = template.content.cloneNode(true);
        const poster = this.querySelector('[data-video-poster]');
        
        if (poster) {
          poster.remove();
        }
        
        container.appendChild(videoContent);
        this.setAttribute('data-loaded', 'true');
      }
    }
  }
}

if (!customElements.get('video-note-section')) {
  customElements.define('video-note-section', VideoNoteSection);
}